import { apiConfig } from "./apiConfig";

const ELITE_TYC_MARCA = "elite_vacances";

const assertApiUrl = () => {
  if (!process.env.REACT_APP_API_URL) {
    throw new Error(
      "REACT_APP_API_URL no está configurada. Crea un archivo .env en la raíz del proyecto.",
    );
  }
};

const getAllTycElite = async () => {
  assertApiUrl();
  return await apiConfig.get("/tyc");
};

const createTycElite = async (payload) => {
  assertApiUrl();
  return await apiConfig.post("/tyc", payload);
};

const updateTycElite = async (id, payload) => {
  return await apiConfig.patch(`tyc/update/${id}`, payload);
};

const deleteTycElite = async (id) => {
  return await apiConfig.delete(`tyc/delete/${id}`);
};

export {
  getAllTycElite,
  createTycElite,
  updateTycElite,
  deleteTycElite,
  ELITE_TYC_MARCA,
};
